export const CRM_REPLACEMENT_VERSION = 'CRM_FULL_REPORT_OCT_2026_V1';
//# sourceMappingURL=member-crm-replacement.js.map